<template>
  <div>
    <div class="card" style="min-height: calc(100vh - 180px)">
      <div class="px-2">
        <DateQuerySetter
            btnTitle="Go"
            @onClickGo="onClickGo"
        >
          <div v-if="permittedAccess.is_all_access" class="col-12 col-sm-6 col-md-3 col-lg-2">
            <label class="col-form-label">Assign to</label>
            <AsyncSelect
                placeholder="Assign to"
                v-model="assignId"
                :api-service="fetchContactProfiles"
                :additional-query="{ with_mobile: 1, roles: 'contact_owner,employee' }"
                :reduce="text => text.id"
            />
          </div>

          <div class="col-12 col-sm-6 col-md-3 col-lg-2">
            <label class="col-form-label">Select Stage</label>
            <v-select
                placeholder="Select Stage"
                :options="dealStageList"
                v-model="dealStageId"
                :reduce="option => option.id"
                label="name"
            />
          </div>

          <div class="col-12 col-sm-6 col-md-3 col-lg-2">
            <label class="col-form-label">Contact Group</label>
            <AsyncSelect
                placeholder="Select"
                v-model="contactGroup"
                :api-service="fetchNoteMasterList"
                :additional-query="{note_type: 'contact_group'}"
                label="name"
                :reduce="option => option"
                class="mb-1"
            />
          </div>

          <div class="col-12 col-sm-6 col-md-3 col-lg-2">
            <label class="col-form-label">Gender</label>
            <select class="form-control" id="gender" v-model="gender">
              <option value="">Select Gender</option>
              <option value="male">Male</option>
              <option value="female">Female</option>
              <option value="others">Others</option>
            </select>
          </div>

          <div class="col-12 col-sm-6 col-md-3 col-lg-2">
            <label class="col-form-label">Religion</label>
            <select class="form-control" id="religion" v-model="religion">
              <option value="">Select Religion</option>
              <option v-for="(religion, key) in religions" :value="key">{{ religion }}</option>
            </select>
          </div>

          <div class="col-12 col-sm-6 col-md-3 col-lg-3">
            <label class="col-form-label">Search</label>
            <input type="text" v-model="searchTerm" class="form-control" placeholder="Search Name and Mobile No">
          </div>

        </DateQuerySetter>
      </div>

      <div class="col-12 px-2">
        <div class="card pipeline-list p-2">
          <div class="table-responsive">
            <table class="table table-bordered">
              <thead>
              <tr>
                <th>Full Name</th>
                <th>Mobile No</th>
                <th>Email</th>
                <th>Address</th>
                <th>Gender</th>
                <th>Religion</th>
                <th>Contact Group</th>
                <th>URL</th>
                <th>Deal Stage</th>
                <th>Date Time</th>
                <th>Action</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item, index) in tableItems" :key="index">
                 <td>{{ item.contact_profile_name }} ({{ item.serial_no }})</td>
                 <td>{{ item.contact_numbers }}</td>
                 <td>{{ item.contact_email }}</td>
                 <td>{{ item.full_address }}</td>
                 <td class="text-capitalize">{{ item.gender }}</td>
                 <td class="text-capitalize">{{ item.contact_religion }}</td>
                 <td>{{ item.contact_group_name }}</td>
                 <td>{{ item.contact_url }}</td>
                 <td>{{ item.deal_stage_name }}</td>
                 <td>{{ item.start_time }}</td>
                 <td>
                   <button class="btn btn-primary btn-sm" @click="goToContactActivities(item)">
                     <i class="fa fa-eye"></i>
                   </button>
                 </td>
              </tr>
              </tbody>
            </table>

            <p v-if="!tableItems.length" class="text-center mt-5">No data</p>
          </div>
        </div>

        <div class="px-2 bottom-0 mt-2">
          <Pagination
              :offset="offset"
              @onPageChange="onPageChange"
              ref="pagination"
          />
        </div>
      </div>

      <Loader v-if="loading"/>
    </div>
  </div>
</template>

<script setup>
import {ref, onMounted, computed, inject, watch} from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from "vuex";
import Loader from "@/components/atom/LoaderComponent.vue";
import AsyncSelect from "@/components/molecule/input-field/AsyncSelect.vue";
import DateQuerySetter from '@/components/atom/DateQuerySetter.vue';
import Pagination from '@/components/atom/Pagination';
import handleContact from "@/services/modules/contact";
import handleProjects from "@/services/modules/procurement/project";
import handleHospital from '@/services/modules/hospital';
import handleChartAccount from '@/services/modules/chartAccount'

const { fetchContactProfiles } = handleContact();
const { getBeneficiaryDashboardList } = handleProjects();
const { fetchNoteMasterList } = handleHospital();
const {fetchHome} = handleChartAccount()

const route = useRoute();
const router = useRouter();
const store = useStore();
const showError = inject('showError');
const showSuccess = inject('showSuccess');
const loading = ref(false);

const start = computed(() => route.query.start);
const end = computed(() => route.query.end);
const page = computed(() => route.query.page);
const companyId = computed(() => route.params.companyId);

const dealStageList = ref([]);
const tableItems = ref([]);
const offset = ref(10);
let permittedAccess = ref({})
let religions = ref([])
let religion = ref(null)
let gender = ref(null)
const assignId = ref(null);
const contactGroup = ref(null);
const dealStageId = ref(null);
const searchTerm = ref('');

const onClickGo = () => {
  getAllListData();
}

const onPageChange = async (page) => {
  let routeQuery = { ...route.query }
  routeQuery.page = page
  await router.push({path: route.path, query: routeQuery})
  await getAllListData()
}

const setPaginationData = (data) => {
  store.commit('setPaginationData', data)
}

const setPagination = (data) => {
  setPaginationData({
    records: data.total,
    perPage: data.per_page,
    currentPage: data.current_page,
  })
}

const goToContactActivities = (item) => {
  let routeQuery = { ...route.query }
  routeQuery.contactId = item.activitylogable_id
  router.push({name: 'beneficiary-register', query: routeQuery})
}

const getAllListData = async () => {
  loading.value = true;
  const query = getQuery();
  tableItems.value = [];
  try {
    const res = await getBeneficiaryDashboardList(query);
    if (!res.status) {
      showError(res.message);
      return store.commit("resetPagination")
    }
    tableItems.value = res.data.data.data;
    permittedAccess.value = res.data.permitted_access;
    setPagination(res.data.data)
  } catch (err) {
    console.error(err);
  } finally {
    loading.value = false;
  }
};

const getQuery = () => {
  let query = '?company_id=' + companyId.value
  query += '&offset=' + offset.value
  if (start) query += '&start_date=' + start.value
  if (end) query += '&end_date=' + end.value
  if(assignId.value) query += '&assign_contact_profile_id=' + assignId.value
  if(dealStageId.value) query += '&stage_id=' + dealStageId.value
  if (page.value) query += '&page=' + page.value
  if (searchTerm.value) query += '&q=' + searchTerm.value
  if (gender.value) query += '&gender=' + gender.value
  if (religion.value) query += '&religion=' + religion.value
  if (contactGroup.value) query += '&contact_group_id=' + contactGroup.value.id
  return query
};

const getDealList = async (noteType, targetList) => {
  const query = `?company_id=${companyId.value}&note_type=${noteType}`;
  try {
    const res = await fetchNoteMasterList(query);
    if (!res.status) {
      return showError(res.message);
    }
    targetList.value = res.data.data;
  } catch (err) {
    console.error(err);
  }
};

onMounted( () => {
  Promise.all([
    getDealList('deal_stage', dealStageList),
    getAllListData(),
    fetchHome().then(res => {
      if (res.data) {
        religions.value = res.data.religions
      }
    })
  ])
})
</script>

<style scoped>
.mr-top-1 {
  margin-top: 1% !important;
}

</style>